import { INSTITUCIONES, getExamConfig } from '../config/institutions'
import '../styles/landing.css'

const details = {
  SEMAR: {
    topics: ['Conocimientos Marineros', 'Legislación Naval', 'Historia y Cultura Naval'],
  },
  GUARDIA_NACIONAL: {
    topics: ['Seguridad Pública', 'Capacidad Operativa y de Servicios', 'Formación y marco jurídico'],
  },
  SEDENA: {
    topics: ['Armas y Servicios', 'Tronco común y especialidad', 'Formación militar'],
  },
}

export default function Institutions() {
  return (
    <section id="instituciones" className="section institutions-section">
      <div className="container">
        <div className="text-center mb-2xl">
          <span className="institutions-eyebrow">⚓ 🛡️ ⭐ Una plataforma, tres instituciones</span>
          <h2>Prepárate para tu ascenso en SEMAR, Guardia Nacional y SEDENA</h2>
          <p className="section-subtitle">
            El mismo ecosistema de estudio, adaptado al temario, jerarquías y especialidades de tu institución.
          </p>
        </div>

        <div className="institution-grid">
          {INSTITUCIONES.map((institucion) => {
            const exam = getExamConfig(institucion.id)
            const topics = details[institucion.id]?.topics || []
            return (
              <article
                key={institucion.id}
                className="institution-card"
                style={{
                  '--inst-accent': institucion.accent,
                  '--inst-accent-light': institucion.accentLight,
                }}
              >
                <div className="institution-emblem" aria-hidden="true">
                  {institucion.emoji}
                </div>
                <h3>{institucion.nombre}</h3>
                <p className="institution-long">{institucion.nombreLargo}</p>

                <ul className="institution-list">
                  {topics.map((topic) => (
                    <li key={topic}>{topic}</li>
                  ))}
                </ul>

                <div className="institution-exam">
                  Simulador de examen:{' '}
                  <strong>
                    {exam.totalQuestions} preguntas · {Math.round(exam.durationSeconds / 60)} min
                  </strong>
                </div>
              </article>
            )
          })}
        </div>

        <p className="institution-note">
          Ascensos App Vortex es una herramienta independiente de estudio. No representa ni cuenta con
          respaldo oficial de SEMAR, Guardia Nacional o SEDENA.
        </p>
      </div>
    </section>
  )
}
